import styled from "styled-components";

export const Container = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-top: 10%;
`

export const Box = styled.div`
    width: 90%;
    max-width: 400px;
    background-color: #f9f9f9;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    gap: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-itens: center;
`

export const ContainerHeader = styled.div`
    text-align: center;
    padding: 10px;
`

export const ContainerContent = styled.div`
    width: 100%;
`

export const ContainerActions = styled.div`
    width: 100%;
    margin-top: 10px;
`

export const Field = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;

    .field-title {
        font-weight: 700;
    }

    .field-value {
        font-weight: 400;
    }
`